var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"RkmForm"},[_c('acidente-trabalho-atendimento',{attrs:{"data":_vm.data,"title":_vm.tituloFormulario(),"disabled":""}}),(_vm.data.model.acidenteTrabalho.parecerMedico)?_c('acidente-trabalho-parecer-medico',{attrs:{"data":_vm.data,"disabled":_vm.disabled}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }